import { createPath } from "rd-url-utils";
//export const HOME_URL = createPath("/reset");
export const ROOT_URL = createPath("/");
export const HOME_URL = createPath<{}, { code: string }>("/reset");
export const RESET_PASS_URL = createPath<{}, { code: string }>("/reset");
export const PORTAL_URL = 'https://portal.gocare.io/#/login';
